/* 顶部导航：鼠标悬停即展开子菜单
 *
 * Dawn 的下拉菜单是 <details>/<summary>，原生只能点击展开。
 * 纯 CSS 打不开 <details>（UA 会隐藏非 summary 子节点，display 覆盖不可靠），
 * 所以用 JS 切换 open 属性。
 *
 * 不要改 details-disclosure.js —— Dawn 的 HeaderMenu 监听 toggle 事件来维护
 * sticky header 的 preventHide 与 --header-bottom-position-desktop
 * （details-disclosure.js:8）。我们设置 open 会正常触发 toggle，那套逻辑照常生效。
 *
 * 做法来自 suusilk 已上线验证的版本（另一会话 2026-09-22 提供），
 * 本文件只改了「关闭同级」那一处，见下方注释。
 */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const SEL = '.header__inline-menu details';
  const CLOSE_DELAY = 150;
  let timer;

  const setOpen = (d, on) => {
    if (d.open === on) return;
    d.open = on;
    const s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', String(on));
  };

  document.addEventListener('mouseover', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const d = t.closest(SEL);
    if (!d) return;
    clearTimeout(timer);
    const menu = d.closest('.header__inline-menu');
    if (menu) {
      menu.querySelectorAll('details[open]').forEach((o) => {
        if (o === d) return;
        // 只关同级，不碰祖先/后代。原版是「除自己外全关」，
        // 在三级菜单下悬停二级会把包着它的一级也关掉，子菜单跟着消失。
        // 本店目前只有两级（线上实测 2 个顶层 details、0 个嵌套），
        // 但 header-dropdown-menu.liquid 支持三级，先把这个坑堵上。
        if (o.contains(d) || d.contains(o)) return;
        setOpen(o, false);
      });
    }
    setOpen(d, true);
  });

  document.addEventListener('mouseout', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const d = t.closest(SEL);
    if (!d) return;
    if (e.relatedTarget instanceof Node && d.contains(e.relatedTarget)) return;
    clearTimeout(timer);
    // 延迟关闭：鼠标从 summary 移到子菜单的途中会短暂离开 details，
    // 立即关的话子项根本点不到。
    timer = setTimeout(() => {
      if (d.matches(':hover')) return;
      setOpen(d, false);
    }, CLOSE_DELAY);
  });

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const s = t.closest(`${SEL} > summary`);
    // 已由 hover 展开时再点 summary，原生行为会把它收起来 —— 拦掉
    if (s && s.parentElement && s.parentElement.open) e.preventDefault();
  });
})();
